export const style = (
  theme,
  width = 880,
  top = "50%",
  left = "50%",
  fullHeight = false,
) => {
  return {
    position: "absolute",
    top: top,
    left: left,
    width: width,
    transform: "translate(-" + left + ", -" + top + ")",
    bgcolor: "background.paper",
    padding: "16px 20px",
    borderRadius: "8px",
    "&:focus-visible": {
      outline: "unset",
    },
    overflowY: "auto",
    height: fullHeight ? "98%" : "unset",
    [theme.breakpoints.down("sm")]: {
      overflowY: "auto",
      height: fullHeight ? "98%" : "unset",
    },
    [theme.breakpoints.down("md")]: {
      width: width > 740 ? 740 : width,
      padding: "12px",
    },
  };
};

export const header = (showHeaderBorder) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "8px",
    marginBottom: "8px",
    "& .MuiSvgIcon-root": {
      cursor: "pointer",
    },
    borderBottom: showHeaderBorder ? "1px solid rgba(0, 64, 87, 0.25)" : "none",
  };
};

export const iconWrapper = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "12px",
};
